import {
    Box,
    Button,
    Chip,
    CircularProgress,
    FormControl,
    IconButton,
    Tooltip,
    Typography,
} from "@mui/material";
import React, { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { exportRAGFile } from 'store';
import classes from "./ImportKnowledgeBase.module.scss";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { getRelativeTime } from "assets/knowledgeDataAssets";
import SimpleTable from "../../../components/SimpleTable/SimpleTable"
import SyncIcon from '@mui/icons-material/Sync';
import SyncDisabledIcon from '@mui/icons-material/SyncDisabled';
//import DeleteIcon from '@mui/icons-material/Delete';
import CloseIcon from '@mui/icons-material/Close';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
//import { deleteRAGFile } from "store";
import { syncRAGFile } from "store";
import { fetchRAGFiles } from "store";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const ImportKnowledgeBaseBox = React.memo(({ onCancel }) => {

    const dispatch = useDispatch();
    const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
    const [showUpload, setShowUpload] = useState(false);
    const [file, setFile] = useState([]);
    const [error, setError] = useState('');
    const fileRef = useRef(null);
    const { ragFileList, loadingRAGFiles, loadingExportRAGFileResponse } = useSelector(state => state.segmenter);
    const handleRagFileData = () => {
        dispatch(fetchRAGFiles());
    }

    const showSnackbar = (message, severity = "success") => {
        setSnackbar({ open: true, message, severity });
    };

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') return;
        setSnackbar({ ...snackbar, open: false });
    };

    const handleFileChange = (e) => {

        const selectedFile = e.target.files[0];
        if (selectedFile) {
            setFile(e.target.files);
            setError('');
        } else {
            setFile([]);
            setError('Please select a valid file.');
        }
    };

    const handleUpload = () => {
        if (!file) {
            setError('No file selected');
            return;
        }


        dispatch(exportRAGFile({ file: file })).unwrap()
            .then((data) => {
                handleReset();
                setShowUpload(true);
                showSnackbar("File Successfully Uploaded...");
            })
            .catch((err) => {
                setError(err.message);
            });

    }

    const handleSync = () => {

        dispatch(syncRAGFile()).unwrap()
            .then((data) => {
                showSnackbar("File Synced Successfully...");
                handleRagFileData();
            })
            .catch((err) => {
                setError(err.message);
            });

    }

    const data = ragFileList.map((e) => {
        return {
            Name: <Tooltip title={e.name}><div className={classes.fileName}> {e.name}</div></Tooltip>,
            Type: e.type,
            "Last Modified": getRelativeTime(e.date),
            Size: e.size,
            "Sync Status": e.current_synced_to_KB ? <IconButton disabled color="primary"><CheckCircleOutlineIcon className={classes.syncIcon} /></IconButton> :
                <>
                    <IconButton disabled color="primary">
                        <SyncDisabledIcon className={classes.unSyncIcon} />
                    </IconButton>
                </>
        }
    });

    const onDragEnter = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    const onDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    const onDragLeave = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    const onDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();

        const files = e.dataTransfer?.files;
        if (!files || files.length === 0) return;

        const fileList = files;
        try {
            const dt = new DataTransfer();
            for (let i = 0; i < fileList.length; i++) dt.items.add(fileList[i]);
            if (fileRef.current) {
                fileRef.current.files = dt.files;
                fileRef.current.dispatchEvent(new Event('change', { bubbles: true }));
            }
        } catch (err) {

            handleFileChange?.({ target: { files: fileList } });
            return;
        }
        handleFileChange?.({ target: { files: fileList } });
    };

    const handleReset = () => {
        setError('');
        setFile([]);
        fileRef.current && (fileRef.current.value = '');
    };

    const handleBack = () => {
        handleRagFileData();
        setShowUpload((prev) => !prev);
    }

    return (

        <Box className={classes.body}>
            <section className={classes.sectionHeader} >
                <IconButton onClick={onCancel} color="primary">
                    <CloseIcon />
                </IconButton>
            </section>
            <section className={classes.section}>
                <section className={classes.header}>
                    <Typography className={classes.title}>Knowledge Base Source</Typography>
                </section>
                <section className={classes.uploadSection} >
                    {showUpload === false && <Button className={classes.boxButton} variant="contained" onClick={handleSync} startIcon={<SyncIcon />}>
                        Sync all
                    </Button>}
                    {!showUpload ? <Button className={classes.boxButton} variant="contained" onClick={() => { setShowUpload((prev) => !prev) }} startIcon={<FileUploadIcon />}>
                        Upload
                    </Button> : <Button className={classes.boxButton} variant="contained" onClick={handleBack} startIcon={<ArrowBackIcon />}>
                        Back
                    </Button>}
                </section>
                <section className={classes.formSection}>
                    {!showUpload ? <FormControl component="fieldset" className={classes.formControlSection}>
                        {loadingRAGFiles ? (
                            <>
                                <div className={classes.importLoader}>
                                    <CircularProgress size="20px" />
                                </div>

                            </>
                        ) : (

                            ragFileList.length === 0 ? <Typography>Knowledge Base is not configured for the current User</Typography> :
                                < SimpleTable data={ragFileList ? data : data} />
                        )}
                    </FormControl> : <><section className={classes.section}>
                        <section className={classes.header}>
                            <Typography className={classes.label}>Select a file below to begin uploading data</Typography></section>
                        <section className={classes.formSection}>
                            <div className={classes.formContent}>
                                {/* <h3>Upload Metafile</h3> */}
                                <label for="images" className={classes.dropContainer} id="dropcontainer"
                                    onDragEnter={onDragEnter}
                                    onDragOver={onDragOver}
                                    onDragLeave={onDragLeave}
                                    onDrop={onDrop}>
                                    <span className={classes.dropTitle}>Drop files here</span>
                                    or
                                    <div className={classes.inputContainer}>
                                        <input ref={fileRef} type="file" accept=".csv,.pdf,.doc,.docx" onChange={handleFileChange} multiple={true} />
                                    </div>
                                </label>
                                {file && <p>Selected files: <strong>{file?.length}</strong></p>}

                                {file && Array.from(file)?.map((elem, idx) => (
                                    <Chip
                                        key={`${elem.name}`}
                                        label={elem.name}
                                        className={classes.chip}
                                    />
                                ))}

                            </div>
                        </section>
                    </section>
                        {error !== '' && <MuiAlert className={classes.muiAlert} severity="error">
                            {error}
                        </MuiAlert>}
                        <br />
                        <section className={classes.formSection}>
                            <Button
                                onClick={handleUpload}
                                variant="contained"
                                className={classes.boxButton}
                                startIcon={<FileUploadIcon />}
                                disabled={loadingExportRAGFileResponse}
                            >
                                Upload
                            </Button>
                        </section></>}
                </section>
                <Snackbar
                    open={snackbar.open}
                    autoHideDuration={5000}
                    onClose={handleSnackbarClose}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                >
                    <MuiAlert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: '100%' }}>
                        {snackbar.message}
                    </MuiAlert>
                </Snackbar>
            </section>
        </Box>
    );
});

export default ImportKnowledgeBaseBox;
